import { TCompanyForm } from "@/features/company/types/CompanyForm";
import { TCreateCompanyReqDto } from "@/api/services/main/company/dtos/create-company-req.dto";
import { TGetCompanyDto } from "@/api/services/main/company/dtos/get-company.dto";
import { DATE_FORMAT_FOR_API } from "@/constants/datetime";
import dayjs from "dayjs";

// hiddenIndustryIds は company_user のみが編集する「取り扱う分野」項目。
// RSO/Admin の作成・更新では UI に出ないため、payload にも含めない（isCompanyUser=false）。
export const convertCompanyFormDataReq = (data: TCompanyForm, isCompanyUser: boolean): TCreateCompanyReqDto => {
  return {
    managementNumber: data.managementNumber ?? null,
    companyName: data.companyName,
    companyKanaName: data.companyKanaName ?? null,
    companySpecificIndustryId1: Number(data.companySpecificIndustryId1),
    companySpecificIndustryId2: data.companySpecificIndustryId2 ? Number(data.companySpecificIndustryId2) : null,
    companySpecificIndustryId3: data.companySpecificIndustryId3 ? Number(data.companySpecificIndustryId3) : null,
    companySpecificBusinessClassificationIds1: data.companySpecificBusinessClassificationIds1?.length ? data.companySpecificBusinessClassificationIds1.map(Number) : null,
    companySpecificBusinessClassificationIds2: data.companySpecificBusinessClassificationIds2?.length ? data.companySpecificBusinessClassificationIds2.map(Number) : null,
    companySpecificBusinessClassificationIds3: data.companySpecificBusinessClassificationIds3?.length ? data.companySpecificBusinessClassificationIds3.map(Number) : null,
    ...(isCompanyUser ? { hiddenIndustryIds: data.hiddenIndustryIds ?? [] } : {}),
    startDate: data.startDate && dayjs(data.startDate).isValid() ? dayjs(data.startDate).format(DATE_FORMAT_FOR_API) : null,
    endDate: data.endDate && dayjs(data.endDate).isValid() ? dayjs(data.endDate).format(DATE_FORMAT_FOR_API) : null,
    contactPersonName: data.contactPersonName ?? null,
    contactPersonEmail: data.contactPersonEmail ? data.contactPersonEmail : null,
    contactPersonPhone: data.contactPersonPhone || null,
    contactPersonJobTitle: data.contactPersonJobTitle ?? null,
    note: data.note ?? null,

  };
};

export const convertResToFormData = (data: TGetCompanyDto): Partial<TCompanyForm> | undefined => {
  if (!data) return undefined;

  return {
    managementNumber: data?.managementNumber,
    companyName: data.companyName,
    companyKanaName: data.companyKanaName,
    companySpecificIndustryId1: data.companySpecificIndustryId1 ?? undefined,
    companySpecificIndustryId2: data.companySpecificIndustryId2 ?? null,
    companySpecificIndustryId3: data.companySpecificIndustryId3 ?? null,
    companySpecificBusinessClassificationIds1: data.companySpecificBusinessClassificationIds1?.map(String) ?? [],
    companySpecificBusinessClassificationIds2: data.companySpecificBusinessClassificationIds2?.map(String) ?? [],
    companySpecificBusinessClassificationIds3: data.companySpecificBusinessClassificationIds3?.map(String) ?? [],
    startDate: data.startDate ? dayjs(data.startDate) : null,
    endDate: data.endDate ? dayjs(data.endDate) : null,
    contactPersonName: data.contactPersonName,
    contactPersonJobTitle: data.contactPersonJobTitle,
    contactPersonPhone: data.contactPersonPhone,
    contactPersonEmail: data.contactPersonEmail,
    note: data.note,
    isArchive: data.isArchive,
    companySpecificIndustry1: data.companySpecificIndustry1,
    companySpecificIndustry2: data.companySpecificIndustry2,
    companySpecificIndustry3: data.companySpecificIndustry3,
    hiddenIndustryIds: data.hiddenIndustryIds ?? [],
    createdAt: data.createdAt,
    updatedAt: data.updatedAt,
  };
};
